<template>
  <div class="error-500">
    <h1>{{$t('error.500.title')}}</h1>
    <p>{{$t('error.500.support')}} <b><a :href="`mailto:${appInfo.cc_email}`">{{ appInfo.cc_email }}</a></b></p>
  </div>
</template>

<script>
import info from '~/data/info.json';

export default {
  name: 'error-500',
  props: {
    error: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      appInfo: info
    }
  }
}
</script>